var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.283,
    height: 102.283,
    viewBox: "0 0 102.283 102.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1.5 100.783) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "E418_Arrow_down_download_downloads",
    "data-name": "E418, Arrow, down, download, downloads",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_275",
    "data-name": "Ellipse 275",
    cx: 49.642,
    cy: 49.642,
    r: 49.642,
    transform: "translate(0)",
    fill: "none",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6124",
    "data-name": "Line 6124",
    y1: 36.489,
    transform: "translate(49.642 32.47)",
    fill: "none",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4558",
    "data-name": "Path 4558",
    d: "M0,10.73,10.732,0,21.464,10.73",
    transform: "translate(38.909 32.472)",
    fill: "none",
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.5a864397ab021dd9ffe2542227963927.svg";
export { ForwardRef as ReactComponent };